export const Types = {
  LOGIN: 'LOGIN',
  SAVE_LOGIN: 'SAVE_LOGIN',
  SAVE_INFO_USER: 'SAVE_INFO_USER',
  SAVE_LIST_USER_LOGIN_PERMISSION: 'SAVE_LIST_USER_LOGIN_PERMISSION',
}
